import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { Grid, Button, Typography, Box } from '@material-ui/core';
import Sucessful from '../assets/images/Sucessful.png';
import Declined from '../assets/images/Declined.png';
const useStyles = theme => ({
    root: {
        position: 'relative',
        // top: '-48px',
        paddingTop: '0',
        padding: '3%',
    },
    button: {
        marginTop: theme.spacing(2),
        width: '200px',
        backgroundColor: '#ffffff',
        fontSize: '15px',
        fontWeight: 'bold',
        color: '#000000',
        "&:hover": {
            backgroundColor: '#ffffff',
            color: '#000000'
        },
    },
    imagesize: {
        marginTop: '5%',
        marginBottom: '5%',
        width: '30%'
    },
});

class ConfirmationPage extends Component {
    close = async () => {
        window.opener = null;
        window.open('', '_self');
        window.close();
    }

    render() {
        const { classes } = this.props;
        return (
            <Grid container className={classes.root}> 
                <Box style={{ height: '550px', display: 'flex', width: '100%', background: '#f3f3f3', padding: '2%', marginTop: '3%', justifyContent: 'center' }}>
                    {this.props.status === true
                        ? <Grid>
                            <Grid container style={{ justifyContent: 'center' }}>
                                <Typography variant="subtitle1" style={{ color: '#000000', fontSize: '1.7rem', fontWeight: 'bold' }} >
                                    You're all signed up!
                                </Typography>
                            </Grid>
                            <img className={classes.imagesize} src={Sucessful} alt='' />
                            <Grid container style={{ justifyContent: 'center' }}>
                                <Typography variant="subtitle1" style={{ color: '#000000', fontSize: '1.7rem', fontWeight: 'bold' }} >
                                    Please check your email for the confirmation we sent you.
                                </Typography>
                            </Grid>
                            <Grid container style={{ justifyContent: 'center' }}>
                                <Button variant="contained" color="primary" className={classes.button} onClick={() => { this.close() }}> Close this window </Button>
                            </Grid>
                        </Grid>
                        : <Grid>
                            <Grid container style={{ justifyContent: 'center' }}>
                                <Typography variant="subtitle1" style={{ color: '#000000', fontSize: '1.7rem', fontWeight: 'bold' }} >
                                    We faced some problem while signing you up.
                                </Typography>
                            </Grid>
                            <img className={classes.imagesize} src={Declined} alt='' />
                            <Grid container style={{ justifyContent: 'center' }}>
                                <Typography variant="subtitle1" style={{ color: '#000000', fontSize: '1.7rem', fontWeight: 'bold' }} >
                                    Please fill the form and try again.
                                </Typography>
                            </Grid>
                            <Grid container style={{ justifyContent: 'center' }}>
                                <Button variant="contained" color="primary" className={classes.button} onClick={() => { window.open('https://opencampground.com/pricing/') }}> Try again </Button>
                            </Grid>
                        </Grid>
                    }


                </Box>
            </Grid>
        );
    };
};

export default withStyles(useStyles)(ConfirmationPage);